import React, { useState, useEffect } from 'react';
import ReactEcharts from 'echarts-for-react';
import cloneDeep from 'lodash.clonedeep';

const IndustryRisk1 = () => {
    const getOption = () => ({
        tooltip: {
            formatter: "{a} <br/>{b} : {c}%"
        },
        toolbox: {
            feature: {
                restore: {},
                saveAsImage: {}
            }
        },
        series: [
            {
                name: 'Industry Risk',
                type: 'gauge',
                detail: { formatter: '{value}%' },
                axisLine: {
                    lineStyle: {
                        color: [
                            [0.2, '#5C6673'],  
                            [0.6, '#A3E566'],  
                            [1, '#2F80F7']      
                        ],
                        width: 20
                    }
                },
                data: [{ value: 69.1, name: 'Industry Risk' }]
            }
        ]
    });

    const [option, setOption] = useState(getOption());

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setOption(prevOption => {
    //             const newOption = cloneDeep(prevOption);
    //             newOption.series[0].data[0].value = parseFloat((Math.random() * 100).toFixed(2));
    //             return newOption;
    //         });
    //     }, 2000);

    //     return () => clearInterval(interval);
    // }, []);

    return <ReactEcharts style={{ height: "350px" }} option={option} />;
};

export default IndustryRisk1;
